import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../Loner";
import {LonerSound} from "../sound/LonerSound";
import {LonerStatics} from "../LonerStatics";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

/**
 * Created by Jerker Nord on 2023-01-13.
 */

export class LonerNormalSpinPresentation implements SimplePresentation {

    private _controller: SimplePresentationRunnerController;

    constructor() {
    }

    public shouldRun(): boolean {
        return true;
    }

    public start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        const isFastSpin: boolean = Loner.apiPlugin.settings.get(APISetting.FAST_SPIN, false);

        const allSpinTL: gsap.core.Timeline = gsap.timeline({
            onComplete: () => this._controller.finish()
        });

        const mainSpinTL: gsap.core.Timeline = gsap.timeline();
        mainSpinTL.add(() => {
            Loner.soundPlayer.playSound(LonerSound.REELS_SPINNING, 1, 10000)
        });
        mainSpinTL.add(Loner.allReelView.mainReelModels[0].start().restart(), isFastSpin ? LonerStatics.betweenReelsStartDelayFast[0] : LonerStatics.betweenReelsStartDelayNormal[0]);
        mainSpinTL.add([
            Loner.allReelView.mainReelModels[1].start().restart(),
            Loner.allReelView.mainReelModels[2].start().restart(),
            Loner.allReelView.mainReelModels[3].start().restart()
        ], isFastSpin ? LonerStatics.betweenReelsStartDelayFast[1] : LonerStatics.betweenReelsStartDelayNormal[1]);
        mainSpinTL.add(Loner.allReelView.mainReelModels[4].start().restart(), isFastSpin ? LonerStatics.betweenReelsStartDelayFast[2] : LonerStatics.betweenReelsStartDelayNormal[2]);

        allSpinTL.add([mainSpinTL]);
    }
}